/*
  Cii search relevance
  ====================
  Shopify's storefront search runs a semantic pass over the whole catalogue. It
  ignores options[fields] and options[prefix], so a bare query is matched loosely
  and the result set balloons: "hijab" returned 185 of 1,831 products and stopped
  being relevant around the 8th card, "kids quran" returned 445 with 1 relevant
  card on the first page.

  Field scoped boolean queries ARE still honoured, so before submitting we rewrite
  what the shopper typed into an explicit scoped query:

      hijab  ->  (title:hijab* OR product_type:hijab* OR tag:hijab* OR ...)

  Their own words travel alongside in `qs` so the page can show them back instead
  of the machinery, and a scoped query that finds nothing falls back to the broad
  search with a note. With no JS the forms submit exactly as they did before.
*/
(function () {
  'use strict';

  var FIELDS = ['title', 'product_type', 'tag', 'vendor', 'variants.sku', 'variants.title'];

  // Filler words that are never in product data and would empty out an AND query.
  var NOISE = [
    'a', 'an', 'and', 'any', 'are', 'buy', 'cheap', 'for', 'from', 'have', 'his',
    'her', 'in', 'is', 'it', 'me', 'my', 'of', 'on', 'or', 'please', 'sa', 'shop',
    'some', 'that', 'the', 'this', 'to', 'want', 'with', 'you', 'your'
  ];

  function words(raw) {
    return String(raw)
      .toLowerCase()
      .replace(/['’]s\b/g, '')
      .split(/[^a-z0-9]+/)
      .filter(function (word) {
        return word.length > 1 && NOISE.indexOf(word) === -1;
      })
      .slice(0, 5);
  }

  function scopedQuery(raw) {
    var parts = words(raw).map(function (word) {
      return (
        '(' +
        FIELDS.map(function (field) {
          return field + ':' + word + '*';
        }).join(' OR ') +
        ')'
      );
    });
    return parts.length ? parts.join(' AND ') : null;
  }

  function searchUrl(action, raw) {
    var scoped = scopedQuery(raw);
    var params = new URLSearchParams();
    params.set('q', scoped || raw);
    if (scoped) params.set('qs', raw);
    params.set('type', 'product');
    return (action || '/search') + '?' + params.toString();
  }

  function broadUrl(raw) {
    var params = new URLSearchParams();
    params.set('q', raw);
    params.set('type', 'product');
    params.set('broad', '1');
    return '/search?' + params.toString();
  }

  function hookForm(form) {
    if (form.dataset.ciiScoped) return;
    var input = form.querySelector('input[type="search"][name="q"]');
    if (!input) return;

    form.dataset.ciiScoped = 'true';
    form.addEventListener('submit', function (event) {
      var raw = input.value.trim();
      if (!raw) return;
      event.preventDefault();
      window.location.assign(searchUrl(form.getAttribute('action'), raw));
    });
  }

  function hookForms() {
    document.querySelectorAll('form').forEach(hookForm);
  }

  function showNote(root, html) {
    var note = root.querySelector('[data-cii-search-note]');
    if (!note) return;
    note.innerHTML = html;
    note.hidden = false;
  }

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = value;
    return div.innerHTML;
  }

  function onSearchPage() {
    var root = document.querySelector('[data-cii-search]');
    if (!root) return;

    var params = new URLSearchParams(window.location.search);
    var human = params.get('qs');
    var isBroad = params.get('broad') === '1';
    var count = parseInt(root.getAttribute('data-results-count'), 10);

    if (human) {
      // Show the shopper their own words, never the query we built for Shopify.
      document.querySelectorAll('input[type="search"][name="q"]').forEach(function (input) {
        input.value = human;
      });

      // Keep them attached when a facet or sort form resubmits.
      document.querySelectorAll('form').forEach(function (form) {
        if (!form.querySelector('input[name="q"]')) return;
        if (form.querySelector('input[name="qs"]')) return;
        var hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'qs';
        hidden.value = human;
        form.appendChild(hidden);
      });

      // Nothing matched on the words themselves, so widen the net once.
      if (count === 0) {
        window.location.replace(broadUrl(human));
        return;
      }
    }

    if (isBroad) {
      showNote(
        root,
        'No exact matches for “' +
          escapeHtml(params.get('q') || '') +
          '”. Showing related products.'
      );
      return;
    }

    if (human && count > 0 && count < 4) {
      showNote(
        root,
        'Showing exact matches for “' +
          escapeHtml(human) +
          '”. <a href="' +
          escapeHtml(broadUrl(human)) +
          '">See related products \u2192</a>'
      );
    }
  }

  function init() {
    hookForms();
    onSearchPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
